class Constants {
  static get SET_SCORE() { return 'setScore'; }

  static get UP_POINTS() { return 'upPoints'; }

  static get SCORE_UPDATED() { return 'scoreUpdated'; }

  static get PLAY_SOUND() { return 'playSound'; }

  static get MUSIC_CHANGED() { return 'musicChanged'; }

  static get TOGGLE_SOUND() { return 'toggleSound'; }

  static get TOGGLE_MUSIC() { return 'toggleMusic'; }
}

export default Constants;